<template>
<div>
  <el-dialog
    title="开具电子发票"
    :visible.sync="dialogButton"
    width="60%"
    :before-close="handleCloseInvoice"
    v-loading="loading"
  >
    <el-form ref="form" :model="invoiceForm" label-width="120px" :rules="rules">
      <el-form-item label="操作类型" v-if="order_type !== 'advance'">
        <el-radio-group v-model="invoiceForm.move_type">
          <el-radio :label="1">开具发票</el-radio>
          <el-radio :label="2">补录发票</el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-if="invoiceForm.move_type === 1">
        <el-form-item label="发票类型" prop="invoice_type" v-if="isDigitization">
          <el-select v-model="invoiceForm.invoice_type">
            <el-option label="电子普票" value="82"></el-option>
            <el-option label="电子专票" value="81"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发票抬头" prop="title">
          <el-autocomplete
            v-model="invoiceForm.title" style="width:100%"
            :fetch-suggestions="remoteSearchInvoiceTitle"
            placeholder="请输入内容"
            @select="handleInvoiceTitleSelect"
          >
            <el-button slot="append" @click="handleSaveTitle">保存</el-button>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="纳税人识别号">
          <el-input v-model="invoiceForm.taxNo" />
        </el-form-item>
        <el-form-item label="是否不动产发票">
        <el-select v-model="invoiceForm.taxAddressType" @change="handleTaxAddressChange">
            <el-option label="否" :value="0"></el-option>
            <el-option label="是" :value="1"></el-option>
          </el-select>
        </el-form-item>
      <el-form-item v-if="invoiceForm.taxAddressType === 1" label="不动产所在省市">
          <el-input v-model="invoiceForm.realEstatePlace" placeholder="请填写所在省市区"></el-input>
      </el-form-item>
        <el-form-item v-if="invoiceForm.taxAddressType === 1" label="不动产详细地址（不含省市）">
          <el-input v-model="invoiceForm.fullAddress" placeholder="请填写详细地址"></el-input>
        </el-form-item>
      <el-form-item label="购方地址">
          <el-input v-model="invoiceForm.address" />
        </el-form-item>
        <template v-if="!isDigitization">
          <el-form-item label="开户行及账号" prop="bank">
            <el-input v-model="invoiceForm.bank" />
          </el-form-item>
          <el-form-item label="电话/邮箱" prop="phone">
            <el-input v-model="invoiceForm.phone" />
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="开户行" prop="bank">
            <el-input v-model="invoiceForm.bank" />
          </el-form-item>
          <el-form-item label="银行账号" prop="bankAccount">
            <el-input v-model="invoiceForm.bankAccount" />
          </el-form-item>
          <el-form-item label="电话" prop="mobile">
            <el-input v-model="invoiceForm.phone" />
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="invoiceForm.email" />
          </el-form-item>
        </template>
        <el-form-item label="备注">
          <el-input v-model="invoiceForm.remark" />
        </el-form-item>
      </div>
      <div v-if="invoiceForm.move_type === 2">
        <el-form-item label="搜索发票">
          <el-input v-model="searchInvoice.invoice_no" placeholder="请输入发票号"></el-input>
          <el-date-picker v-model="searchInvoice.invoice_date" placeholder="请输入开票时间" type="month" value-format="yyyyMM"></el-date-picker>
          <el-button type="primary" size="mini" @click="handleSearchResult">查询</el-button>
        </el-form-item>
        <el-form-item label="搜索结果">
          <el-table :data="searchResult">
            <el-table-column label="发票号" prop="invoiceNo"></el-table-column>
            <el-table-column label="开票日期" prop="invoiceDate"></el-table-column>
            <el-table-column label="类型">
              <template #default="scope">
                <span v-if="scope.row.invoiceKindCode === 81">专票</span>
                <span v-else>普票</span>
              </template>
            </el-table-column>
            <el-table-column label="税额" prop="taxAmount"></el-table-column>
            <el-table-column label="合计金额" prop="totalAmount"></el-table-column>
          </el-table>
        </el-form-item>
      </div>
      <el-form-item label="开票总金额" v-if="send_method">
        {{ (invoiceForm.invoice_total).toFixed(2) }}
      </el-form-item>
<!--      <el-form-item label="是否部分挂账" v-if="order_type !== 'paid_order'">-->
<!--        <el-select v-model="invoiceForm.is_part">-->
<!--          <el-option label="是" :value="1"></el-option>-->
<!--          <el-option label="否" :value="0"></el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
      <el-form-item label="挂账金额" v-if="invoiceForm.is_part">
        <el-table :data="orderList">
          <el-table-column prop="chargeItem_name" label="收费项"></el-table-column>
          <el-table-column prop="h_name_date" label="房产"></el-table-column>
          <el-table-column label="周期">
            <template #default="scope">
              {{scope.row.startDate}} - {{scope.row.endDate}}
            </template>
          </el-table-column>
          <el-table-column label="订单数">
            <template #default="scope">
             {{typeof scope.row.id == 'string' ? scope.row.id.split(',').length : 1 }}
            </template>
          </el-table-column>
          <el-table-column label="应收金额">
            <template #default="scope">
              {{ scope.row.charge }}
            </template>
          </el-table-column>
          <el-table-column label="挂账金额">
            <template #default="scope">
              <el-input size="mini" v-model="scope.row.invoice_money" @blur="handleInvoiceMoneyChange(scope)"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="开票税盘" v-if="discList.length > 1">
        <el-select v-model="invoiceForm.disc_id" style="width:80%">
          <el-option v-for="item in discList" :key="item.id" :label="'开票人：' + item.drawer + ' 备注：' + item.remark" :value="item.id"></el-option>
        </el-select>
        <el-button @click="handleSetDefaultDisc">设置为默认税盘</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="issueInvoice">保存</el-button>
        <el-button @click="handleCloseInvoice">取消</el-button>
        <el-button @click="loadLastInvoiceForm">读取上次开票信息</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</div>
</template>

<script>
export default {
  data(){
    return {
      invoiceForm : {
        invoice_total : 0,
      },
      discList : [],
      isDigitization: false,
      dialogButton :false,
      loading :false,
      rules: {
        title: [{ required: true, message: "请填写发票抬头", trigger: "blur" }],
        phone: [
          { required: true, message: "请填写电话/邮箱", trigger: "blur" },
        ],
      },
      pid : 0,

      searchInvoiceTitle : '',
      titleLoading: false,
      titleOptions: [],
      selectTitleId : 0,
      timeout : null,

      orderList : [],

      searchInvoice : {
        invoice_no : '',
        invoice_date : '',
        invoice_type : '',
      },
      searchResult : [],
    };
  },
  props : {
    order_type : {
      type : String , default : 'paid_order'
    },
    send_method : {
      type : Boolean , default : true
    }
  },
  methods : {
    getDefaultForm(){
      return {
        title : '',
        address : '',
        remark : '',
        taxNo : '',
        bank : '',
        bankAccount : '',
        email : '',
        mobile : '',
        phone : '',
        invoice_type : '82',
        orderDetailIds : [],
        orderIds : [],
        advanceIds : [],
        taxAddressType : 0,
        realEstatePlace : '',
        fullAddress : '',
        is_part : 0,
        invoice_total : 0 ,
        move_type : 1 ,
        tax_total : 0 ,
        disc_id : 0 ,
      };
    },
    handleCloseInvoice(){
      this.dialogButton = false;
      this.$emit('close' , true);
    },
    openInvoiceForm(pid , orderList){
      this.dialogButton = true;
      this.pid = pid;
      this.invoiceForm = this.getDefaultForm();
      this.discList = [];
      this.orderList = orderList.map(item => ({
        ...item,
        invoice_money: item.charge,
      }));
      this.invoiceForm.invoice_total = this.orderList.reduce(
        (total, item) => total + (parseFloat(item.invoice_money) || 0),
        0
      );
      this.invoiceForm.title = orderList[0].customer || "";
      this.invoiceForm.address = orderList[0].h_name_date || '';
      this.invoiceForm.remark = orderList[0].h_name_date || '';
      this.invoiceForm.is_part = 0;
      let that = this;
      if(this.order_type === 'not_pay_order'){
        // 挂账开票
        orderList.forEach(item => {
          // item.id 根据逗号拆分
          if(typeof item.id === 'string' && item.id.indexOf(',') > -1){
            item.id.split(',').forEach(id => {
              that.invoiceForm.orderIds.push(id);
            })
          }else{
            that.invoiceForm.orderIds.push(item.id);
          }
        })
      }else if(this.order_type === 'paid_order'){
        // 已缴费开票
        orderList.forEach(item => {
          // item.id 根据逗号拆分
          if(typeof item.id === 'string' && item.id.indexOf(',') > -1){
            item.id.split(',').forEach(id => {
              that.invoiceForm.orderDetailIds.push(id);
            })
          }else{
            that.invoiceForm.orderDetailIds.push(item.id);
          }
        })
      }else if(this.order_type === 'advance'){
        // 预收款开票
        this.invoiceForm.title = orderList[0].name || "";
        this.invoiceForm.address = orderList[0].house || '';
        this.invoiceForm.remark = orderList[0].house || '';
        this.invoiceForm.invoice_total = 0;
        orderList.forEach(item => {
          // item.id 根据逗号拆分
          if(typeof item.id === 'string' && item.id.indexOf(',') > -1){
            item.id.split(',').forEach(id => {
              that.invoiceForm.advanceIds.push(id);
            })
          }else{
            that.invoiceForm.advanceIds.push(item.id);
          }
          this.invoiceForm.invoice_total += (parseFloat(item.money) || 0);
        })
      }
      this.checkIsDigitization();
    },
    checkIsDigitization() {
      let that = this;
      let searchType = this.order_type === 'advance' ? '' : 'not_pay_order';
      this.$myhttp
        .post(
          "admin/InvoiceDisc/checkIsDigitization",
          { pid: this.pid , order_type : searchType , order_ids : this.invoiceForm.orderIds },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.isDigitization = backdata.data.data.is_digitization;
            if(backdata.data.data.is_estate_lease){
              that.invoiceForm.taxAddressType = 1;
              that.invoiceForm.realEstatePlace = backdata.data.data.real_estate_place;
              that.invoiceForm.fullAddress = backdata.data.data.full_address;
            }else{
              that.invoiceForm.taxAddressType = 0;
            }
            if(this.isDigitization) {
              if(backdata.data.data.hasOwnProperty('disc_list') && backdata.data.data.disc_list.length > 1){
                that.discList = backdata.data.data.disc_list;
                let cacheKey = 'electronic_invoice_form_default_disc_id';
                let cacheData = localStorage.getItem(cacheKey);
                if(cacheData){
                  that.invoiceForm.disc_id = parseInt(cacheData);
                }else{
                that.invoiceForm.disc_id = backdata.data.data.disc_list[0].id;
                }
              }else{
                that.invoieForm.disc_id = 0;
              }
            }
          }
        })
        .catch((err) => {});
    },
    issueInvoice() {
      if(this.invoiceForm.move_type == 2){
        // 补录发票
        if(this.searchResult.length == 0){
          this.$message.error("请选择要补录的发票");
          return null;
        }
        if(parseFloat(this.searchResult[0].totalAmount) !== parseFloat(this.invoiceForm.invoice_total)){
          this.$message.error('补录的发票金额和订单开票金额不一致');
          return null;
        }
        this.invoiceForm.invoice_no = this.searchResult[0].invoiceNo;
        this.invoiceForm.invoice_date = this.searchResult[0].invoiceDate;
        this.invoiceForm.invoice_type = this.searchResult[0].invoiceKindCode;
        this.invoiceForm.tax_total = this.searchResult[0].taxAmount;
      }else{
        // 保存开票信息到缓存
        let cacheKey = 'electronic_invoice_form_cache';
        localStorage.setItem(cacheKey , JSON.stringify(this.invoiceForm));
      }
      // 发票信息
      this.invoiceForm.order_list = this.orderList;

      this.invoiceForm.order_type = this.order_type;
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.invoiceForm.pid = this.pid;
          if(this.send_method){
            this.loading = true;
            let url = this.order_type === 'advance' ? 'admin/Invoice/issueInvoiceAdvance' : 'admin/Invoice/issueInvoice';
            // 组件内发送开票接口
          this.$myhttp
            .post(url, this.invoiceForm, {
              "Content-Type": "application/json",
            })
            .then((backdata) => {
              if (backdata.data.code == 200) {
                this.$message.success(backdata.data.msg);
                this.loading = false;
                this.handleCloseInvoice();
              } else {
                this.$message.error(backdata.data.msg);
                this.loading = false;
              }
            })
            .catch((err) => {
              this.$message.error(err);
              this.loading = false;
            });
        } else {
            // 发送请求，返回表单数据到上一层
            this.$emit('sendInvoice' , this.invoiceForm);
            this.dialogButton = false;
          }
        } else {
          this.loading = false;
        }
      });
    },
    remoteSearchInvoiceTitle(query , cb) {
      this.$myhttp.get("admin/invoiceTitle?pid=" + this.pid + "&keyword=" + query, {
        "Content-Type": "application/x-www-form-urlencoded",
      }).then((backdata) => {
        if(backdata.data.code == 200){
          clearTimeout(this.timeout);
          this.titleOptions = backdata.data.data;
          this.timeout = setTimeout(() => {
            let option = [];
            backdata.data.data.forEach((item) => {
              option.push({
                value: item.title,
                label: item.title + '-' + item.tax_no,
                id : item.id,
              });
            })
            cb(option);
          }, 3000 * Math.random());
        }
      })
    },
    handleInvoiceTitleSelect(data){
      this.selectTitlteId = data.id;
      this.titleOptions.forEach((item) => {
        if(item.id == data.id){
          this.invoiceForm.phone = item.phone
          this.invoiceForm.address = item.address
          this.invoiceForm.taxNo = item.tax_no
          this.invoiceForm.bank = item.bank
          this.invoiceForm.bankAccount = item.bank_account
          this.invoiceForm.email = item.email
        }
      })
    },
    handleSaveTitle() {
      let data = {
        pindex_id : this.pid,
        title : this.invoiceForm.title,
        phone : this.invoiceForm.phone,
        address : this.invoiceForm.address,
        tax_no : this.invoiceForm.taxNo,
        bank : this.invoiceForm.bank,
        bank_account : this.invoiceForm.bankAccount,
        email : this.invoiceForm.email,
        id : this.selectTitlteId,
      };

      if(this.selectTitlteId > 0) {
        this.$confirm('刚才有勾选过抬头信息，请选择当前信息保存方式:', '提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: '覆盖保存',
          cancelButtonText: '新增保存',
          type: 'warning'
        }).then(() => {
          // 覆盖保存
          this.saveTitleData(data);
        }).catch(action => {
          if(action === 'cancel') {
            // 新增保存(清空ID)
            data.id = 0;
            this.saveTitleData(data);
          }
        });
      } else {
        // 新增保存
        this.$confirm('是否保存发票抬头、纳税人识别号、地址、开户行、银行帐号、电话、邮箱信息？', '提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          this.saveTitleData(data);
        })
      }
    },
    saveTitleData(data) {
      this.$myhttp.post("admin/saveInvoiceTitle", data ,{
        "Content-Type": "application/x-www-form-urlencoded",
      }).then((backdata) => {
        if(backdata.data.code == 200){
          this.$message.success(backdata.data.msg);
        }else{
          this.$message.error(backdata.data.msg);
        }
      });
    },
    handleSearchResult(){
      this.$myhttp.post(
        "admin/taxInvoiceList",
        {
          pid : this.pid ,
          search_month : this.searchInvoice.invoice_date,
          invoiceNo : this.searchInvoice.invoice_no,
          disc_id : this.invoiceForm.disc_id ,
        },
        {"Content-Type": "application/json",}
      ).then(res => {
        if(res.data.code == 200){
          if(res.data.data.length == 0){
            this.$message.error('没有找到数据');
          }else if(res.data.data[0].is_erp_exist){
            this.$message.error('发票号[' + this.searchInvoice.invoice_no + ']已收录在ERP系统上，无需进行补录');
          // }else if(res.data.data[0].taxAmount < 0){
          //   this.$message.error('发票号[' + this.searchInvoice.invoice_no + ']已红冲无需补录');
          // } else if(res.data.data[0].invoiceStatus != '01'){
          //   this.$message.error('发票号[' + this.searchInvoice.invoice_no + ']已红冲无需补录');
          }else if(parseFloat(res.data.data[0].totalAmount) != parseFloat(this.invoiceForm.invoice_total)) {
            this.$message.error('发票号[' + this.searchInvoice.invoice_no + ']金额与订单金额不一致，无法补录');
          }else{
            this.searchResult = res.data.data;
          }
        }else{
          this.$message.error(res.data.msg);
        }
      })
    },
    handleInvoiceMoneyChange(scope) {
      if(scope.row.invoice_money > scope.row.charge){
        this.$message.error('发票金额不能大于收费金额');
        this.$set(scope.row, 'invoice_money', scope.row.charge);
        return ;
      }

      // 确保属性变更可被检测
      this.$set(scope.row, 'invoice_money', scope.row.invoice_money);

      // 可选：重新计算总金额
      this.invoiceForm.invoice_total = this.orderList.reduce(
        (total, item) => total + (parseFloat(item.invoice_money) || 0),
        0
      );
    },
    handleTaxAddressChange(){
      if(this.invoiceForm.taxAddressType === 1){
        this.$myhttp.post("admin/getInvoiceAddress", {id : this.pid} ,{
          "Content-Type": "application/x-www-form-urlencoded",
        }).then((backdata) => {
          if(backdata.data.code == 200){
            this.invoiceForm.realEstatePlace = backdata.data.data.realEstatePlace;
            this.invoiceForm.fullAddress = backdata.data.data.fullAddress;
          }else{
            this.$message.error(backdata.data.msg);
          }
        });
      }
    },
    loadLastInvoiceForm(){
      let cacheKey = 'electronic_invoice_form_cache';
      let cacheData = localStorage.getItem(cacheKey);
      if(cacheData){
        let invoiceData = JSON.parse(cacheData);
        if(invoiceData){
          this.invoiceForm.title = invoiceData.title;
          this.invoiceForm.address = invoiceData.address;
          this.invoiceForm.remark = invoiceData.remark;
          this.invoiceForm.taxNo = invoiceData.taxNo;
          this.invoiceForm.bank = invoiceData.bank;
          this.invoiceForm.bankAccount = invoiceData.bankAccount;
          this.invoiceForm.email = invoiceData.email;
          this.invoiceForm.mobile = invoiceData.mobile;
          this.invoiceForm.phone = invoiceData.phone;
          this.invoiceForm.invoice_type = invoiceData.invoice_type;
          this.invoiceForm.taxAddressType = invoiceData.taxAddressType;
          this.invoiceForm.realEstatePlace = invoiceData.realEstatePlace;
          this.invoiceForm.fullAddress = invoiceData.fullAddress;
          this.invoiceForm.disc_id = invoiceData.disc_id;
          }
      }else{
        this.$message.error('没有上次开票的数据');
      }
    },
    handleSetDefaultDisc(){
      // 设置默认税盘
      let cacheKey = 'electronic_invoice_form_default_disc_id';
      localStorage.setItem(cacheKey, this.invoiceForm.disc_id);
      this.$message.success('设置成功');
    }

  }
}
</script>

<style scoped>
.electronicInvoice /deep/ .el-autocomplete {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/order/electronicInvoiceForm.vue